import { render } from "./ScheduledSMS.vue?vue&type=template&id=06607cf8&scoped=true"
import script from "./ScheduledSMS.vue?vue&type=script&lang=js"
export * from "./ScheduledSMS.vue?vue&type=script&lang=js"

import "./ScheduledSMS.vue?vue&type=style&index=0&id=06607cf8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06607cf8"]])

export default __exports__